<template>
  <YorkbbsImage ref="detailImage" :preview-src-list="imageList" :src="previewURL" v-show="false"></YorkbbsImage>
</template>
<script>
export default {
  name: 'ImagePreview',
  props: {
    // 图片选择器字符串
    selector: {
      type: String,
      default: '.editor-txt-content img:not(.facial-expression):not(.spaceline)',
    },
  },
  data() {
    return {
      // 图片URL列表
      imageList: [],
      // 当前预览的图片地址
      previewURL: '',
    };
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      const imageEls = document.querySelectorAll(this.selector);
      this.imageList = [...imageEls].map(el => el.src);
      this.previewURL = this.imageList[0];
      const showImageViewer = e => {
        if (e.target && e.target.src) {
          this.previewURL = e.target.src;
        }
        this.$refs.detailImage.$refs.elImage.clickHandler();
      };
      [...imageEls].forEach(el => el.addEventListener('click', showImageViewer));
      this.$once('hook:beforeDestroy', () =>
        [...imageEls].forEach(el => el.removeEventListener('click', showImageViewer)),
      );
    },
  },
};
</script>
